import { useMessageSource } from "react-message-source";
import { useFormatNumber } from "../../../shared/hooks/useFormatNumber";
import { CardLimitType } from "./types";

interface UseCardLimitOptionsValueType {
  id: string;
  value: CardLimitType;
  label: string;
}

export default function useCardLimitOptionsValues(): UseCardLimitOptionsValueType[] {
  const { getMessage } = useMessageSource();
  const { formatStringAsAmount } = useFormatNumber();

  return [
    {
      id: "card-limit-5000",
      value: CardLimitType.LIMIT_5000,
      label: formatStringAsAmount(CardLimitType.LIMIT_5000.toString()),
    },
    {
      id: "card-limit-10000",
      value: CardLimitType.LIMIT_10000,
      label: formatStringAsAmount(CardLimitType.LIMIT_10000.toString()),
    },
    {
      id: "card-limit-20000",
      value: CardLimitType.LIMIT_20000,
      label: formatStringAsAmount(CardLimitType.LIMIT_20000.toString()),
    },
    {
      id: "card-limit-other",
      value: CardLimitType.LIMIT_OTHER,
      label: getMessage("Value.other"),
    },
  ];
}
